module.exports = __webpack_public_path__ + "static/202182-17439-bd02326ff6f379be1dbd8bafde702e9e.jpeg";